import { useDispatch, useSelector } from "react-redux";
import UserProfile from "../../../../lms-shared/UI/UserProfile";
import classes from './EditPost.module.css'
import { ObjectTypeEnum, ObjectTypeEnumText } from "../../../../../models/ObjectTypeEnum";
import { useEffect, useState } from "react";
import ProjectShareDetails from "./ProjectShareDetails";
import { useParams } from "react-router-dom";
import { messagesApi, postsApi } from "../../../../../utils";
import ConfirmShareProjectPopup from "./ConfirmShareProjectPopup";
import DeleteSharePostPopup from './DeleteSharePostPopup'
import AllowCode from "./AllowCode";
import SpecificFriends from "./SpecificFriends/SpecificFriends";
import External from "./External";
import { TargetObjectIdEnum } from "../../../../../models/TargetObjectIdEnum";
import { PermmisionPostsTypeEnum, PermmisionPostsTypeEnumText } from '../../../../../models/PermmisionPostsTypeEnum'
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import DynamicMessage from "../../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../../../lms-shared/models/DynamicMessageTypeEnum";
import { cretaeMessageContent } from "../../../../lms-shared/functions/Message";


const EditPost = ({ setLoading, index, allPost, setDataPost, newPost, setNewPost, editPostFromPosts, getSelectedList, setShowPopup, close, dataPost, project, beenSharedBefore, setProjectData, setBeenSharedBefore, changePosts, setClickShowShareProjectPopup, friendsData, saveVersion }) => {
    const texts = useSelector(state => state.translate.texts);
    const user = useSelector(state => state.auth.user);

    const { studyGroupId } = useParams()
    const [permissinType, setPermissinType] = useState()
    const [optionsSelect, setOptionsSelect] = useState()
    const [show, setShow] = useState(true);
    const [choosenFriends, setChoosenFriends] = useState({ 'RunnerOnly': [], 'RunnerAndCode': [] });
    const [friendsList, setFriendsList] = useState();
    const [message, setMessage] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {
        if (friendsData) {
            let friends = [...friendsData.map(f => ({ targetObjectId: f.id, name: `${f.user.firstName} ${f.user.lastName[0]}.` }))];
            if (beenSharedBefore && ObjectTypeEnum[dataPost?.shares?.[0]?.targetObjectType] == ObjectTypeEnum.User) {
                let RunnerOnly = [], RunnerAndCode = [];
                dataPost.shares.forEach(friend => {
                    const friendObj = { targetObjectId: friend.targetObjectId, targetObjectType: "User", permissionMask: friend.permissionMask, name: friend.name || `${friend.targetObjectFirstName} ${friend.targetObjectLastName[0]}.` };
                    if (PermmisionPostsTypeEnum[friend.permissionMask] === PermmisionPostsTypeEnum.RunnerOnly) {
                        RunnerOnly.push(friendObj);
                    }
                    if (PermmisionPostsTypeEnum[friend.permissionMask] === PermmisionPostsTypeEnum.RunnerAndCode) {
                        RunnerAndCode.push(friendObj);
                    }
                    friends = friends.filter(f => f.targetObjectId !== friend.targetObjectId);
                });
                setChoosenFriends({ RunnerAndCode, RunnerOnly });
            }
            setFriendsList(friends);
        }
    }, [friendsData, beenSharedBefore]);

    function deletePost() {
        if (dataPost) {
            setShowPopup(<DeleteSharePostPopup shareType={ObjectTypeEnum[dataPost.shares[0].targetObjectType]} setShowPopup={setShowPopup} close={() => close()} dataPost={dataPost} id={dataPost?.id} beenSharedBefore={true} setBeenSharedBefore={setBeenSharedBefore} getSelectedList={getSelectedList} />)
        }
    }

    useEffect(() => {
        if (dataPost) {
            setPermissinType(PermmisionPostsTypeEnumText[dataPost.shares?.[0].permissionMask])
            setOptionsSelect(ObjectTypeEnum[dataPost.shares?.[0].targetObjectType])
        }
        else {
            let selectedArray = Object.keys(getSelectedList())
            setOptionsSelect(selectedArray[0])
            setPermissinType(PermmisionPostsTypeEnumText.RunnerOnly)
        }
    }, [dataPost]);

    function updatePost() {
        if (dataPost) {
            let data = {
                id: dataPost.id,
                name: dataPost.name,
                description: null,
                targetObjectType: ObjectTypeEnumText.ConstUserGroup,
                studyGroupId,
                shares: [
                    {
                        targetObjectId: dataPost.shares[0].targetObjectId,
                        permissionMask: permissinType
                    }

                ]

            }
            if (!optionsSelect || Number(optionsSelect) === ObjectTypeEnum.StudyGroup) {
                let share = {
                    targetObjectId: studyGroupId,
                    permissionMask: permissinType
                }
                let currentTargetObjectType = ObjectTypeEnumText.StudyGroup
                data.shares[0] = share
                data.targetObjectType = currentTargetObjectType
            }
            else {
                if (Number(optionsSelect) === ObjectTypeEnum.User) {
                    if (choosenFriends.RunnerAndCode.length || choosenFriends.RunnerOnly.length) {
                        let chosenFriends1 = choosenFriends.RunnerAndCode.map(x => ({
                            targetObjectId: x.targetObjectId,
                            permissionMask: PermmisionPostsTypeEnumText.RunnerAndCode
                        }));
                    
                        let choseFriends2 = choosenFriends.RunnerOnly.map(x => ({
                            targetObjectId: x.targetObjectId,
                            permissionMask: PermmisionPostsTypeEnumText.RunnerOnly
                        }));
        
                        data.shares = [...chosenFriends1, ...choseFriends2];
        
                        data.targetObjectType = ObjectTypeEnumText.User;
                    }
                    else {
                        data.shares = [];
                    }
                }
            }
            postsApi.postsUpdatePost({ postUpdateInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsUpdatePost " + error.message, level: 1, component: "EditPost", line: 113 }))
                }
                else {
                    changePosts && changePosts(dataPost)
                    setShowPopup(<ConfirmShareProjectPopup close={() => close()} title={texts["successUpdatePostTitle"]} text={texts["successUpdatePost"]} type={"successUpdatePost"} optionsSelect={optionsSelect} />)
                }
            })
        }
    }

    function updateContentPost() {
        postsApi.postsUpdateContentIdPost(dataPost?.id, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsUpdateContentIdPost " + error.message, level: 1, component: "EditPost", line: 126 }))
            }
            else {
                if (dataPost) {
                    let newAllPost = [...allPost]
                    let newPost = { ...dataPost, hasChange: !dataPost.hasChange }
                    newAllPost[index] = { ...newPost }
                    setDataPost(newAllPost)
                    changePosts && changePosts(newPost)
                }
                else {
                    dataPost.hasChange = true
                }
                setShowPopup(<ConfirmShareProjectPopup close={() => close()} title={texts["successUpdatePostTitle"]} text={texts["successUpdatePost"]} type={"successUpdatePost"} optionsSelect={optionsSelect} />)


            }
        })
    }

    function handleSelected(value) {
        setOptionsSelect(value)

    }

    function sendMessage(idPost, idFriends) {

        const textHe = `${user.firstName} ${user.lastName.charAt(0)}. ${texts.sharePostNewMesageHe} ${project.name}`
        const textAr = `${user.firstName} ${user.lastName.charAt(0)}. ${texts.sharePostNewMesageAr} ${project.name}`
        const textEn = `${user.firstName} ${user.lastName.charAt(0)}. ${texts.sharePostNewMesageEn} ${project.name}`
        const link = `${studyGroupId}/friends`;
        const content = cretaeMessageContent(textHe, textAr, textEn, link);

        let messageAddOrUpdateInput = []
        idFriends.map(f => {
            messageAddOrUpdateInput.push({
                refObjectId: studyGroupId,
                refObjectType: ObjectTypeEnumText.StudyGroup,
                sourceObjectId: user.id,
                sourceObjectType: ObjectTypeEnumText.User,
                targetObjectId: f.targetObjectId,
                targetObjectType: ObjectTypeEnumText.User,
                expiredDate: null,
                content: content
            })
        })
        messagesApi.messagesAddRangePost({ messageAddOrUpdateInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 1, component: "EditPost", line: 124 }))
            }
        })
    }

    function publishPost() {
        if (project && project.id) {
            setMessage(null)
            let RunnerAndCode = []
            let RunnerOnly = []
            let data = {
                name: project?.name,
                refObjectId: project?.id,
                refObjectType: ObjectTypeEnumText.Project,
                targetObjectType: ObjectTypeEnumText.ConstUserGroup,
                studyGroupId,
                shares: [
                    {
                        targetObjectId: TargetObjectIdEnum.ConstUserGroup,
                        permissionMask: permissinType
                    }
                ]
            }
            if (Number(optionsSelect) === ObjectTypeEnum.StudyGroup) {
                let share = {
                    targetObjectId: studyGroupId,
                    permissionMask: permissinType
                }
                let currentTargetObjectType = ObjectTypeEnumText.StudyGroup
                data.shares[0] = share
                data.targetObjectType = currentTargetObjectType
            }

            if (Number(optionsSelect) === ObjectTypeEnum.User) {
                RunnerAndCode = choosenFriends.RunnerAndCode.map(x => ({ ...x, permissionMask: PermmisionPostsTypeEnumText.RunnerAndCode }))
                RunnerOnly = choosenFriends.RunnerOnly.map(x => ({ ...x, permissionMask: PermmisionPostsTypeEnumText.RunnerOnly }))

               let chosenFriends1 = choosenFriends.RunnerAndCode.map(x => ({
                    targetObjectId: x.targetObjectId,
                    permissionMask: PermmisionPostsTypeEnumText.RunnerAndCode
                }));
            
                let chosenFriends2 = choosenFriends.RunnerOnly.map(x => ({
                    targetObjectId: x.targetObjectId,
                    permissionMask: PermmisionPostsTypeEnumText.RunnerOnly
                }));

                data.shares = [...chosenFriends1, ...chosenFriends2];
                data.targetObjectType = ObjectTypeEnumText.User;
                if (!choosenFriends.RunnerOnly.length && !choosenFriends.RunnerAndCode.length) {
                    setLoading(false)
                    setMessage(<DynamicMessage
                        type={DynamicMessageTypeEnum.Error}
                        title={texts.Error}
                        content={texts.MessageContentSharesIsNull}
                        confirmFunc={() => { setMessage(null) }} />)
                    return;
                }
            }
            if (Number(optionsSelect) === ObjectTypeEnum.External) {
                let share = {
                    targetObjectId: TargetObjectIdEnum.External,
                    permissionMask: permissinType
                }
                data.shares[0] = share;
            }
            postsApi.postsAddPost({ postAddInput: data }, (error, resdata, response) => {
                if (error) {
                    setLoading(false)
                    dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "postsAddPost " + error.message, level: 1, component: "EditPost", line: 235 }))
                }
                else {
                    setLoading(false)
                    setClickShowShareProjectPopup && setClickShowShareProjectPopup(false)
                    setNewPost && setNewPost(true)
                    resdata.user = user
                    setDataPost([resdata])
                    changePosts && changePosts(resdata)
                    setShowPopup(<ConfirmShareProjectPopup close={() => close()} text={texts["successPublishPost"]} type={"successPublishPost"} optionsSelect={optionsSelect} dataPost={resdata} />)
                    setBeenSharedBefore(true)
                    if (Number(optionsSelect) === ObjectTypeEnum.User)
                        sendMessage(response.body.id, [...RunnerAndCode, ...RunnerOnly])
                }
            })
        }

        else {
            setLoading(false)
            setMessage(<DynamicMessage
                type={DynamicMessageTypeEnum.Error}
                content={texts.MessageContentPostWithoutProject}
                confirmFunc={() => setMessage(false)} />)
        }
    }

    const createOptions = () => {
        const selected = getSelectedList()
        return (
            <>
                {Object.keys(selected).map((s, i) => <option key={s} className={classes.Option} value={s}>{selected[s]}</option>)}
            </>)

    }

    const changeSpecificFriends = (_choosenFriends) => {
        if (dataPost) {
            let newAllPosts = [...allPost]
            newAllPosts[index].shares = [..._choosenFriends.RunnerAndCode, ..._choosenFriends.RunnerOnly]
            setDataPost(newAllPosts)
        }
    }

    const getRemoveText = () => {
        if (dataPost?.shares?.[0].targetObjectId === TargetObjectIdEnum.External) {
            return texts.cancelExternalLink;
        }
        return texts.removePost;
    }

    const handlePublishPost = () => {
        if (saveVersion) {
            setMessage(<DynamicMessage
                type={DynamicMessageTypeEnum.Warn}
                title={texts.saveProject}
                content={texts.MessageContentSaveProjectWarn}
                cancelFunc={() => setMessage(null)}
                confirmFunc={() => {
                    saveVersion(() => {
                        publishPost();
                    }, setLoading);
                }} />)
        }
        else {
            publishPost();
        }
    }

    return (
        <>
            {message}
            <div>
                {!beenSharedBefore && <div className={classes.ProfileAndShareContainer}>
                    <div className={classes.ProfileContainer}>
                        <UserProfile width="43px" />
                        <div className={classes.ProfileAndShare}>
                            <p className={classes.UserName}>{user?.firstName} {user?.lastName}</p>
                            <select className={classes.SelectContainer} value={optionsSelect} onChange={(e) => handleSelected(e.target.value)}>
                                {createOptions()}
                            </select>
                        </div>
                    </div>
                </div>}
                <div className={classes.ProjectContainer}>
                    {optionsSelect == ObjectTypeEnum.User && <SpecificFriends changeSpecificFriends={changeSpecificFriends} beenSharedBefore={beenSharedBefore} show={show} setShow={setShow} friendsList={friendsList} setFriendsList={setFriendsList} choosenFriends={choosenFriends} setChoosenFriends={setChoosenFriends} />}
                    <p className={classes.ProjectName}>{project?.name}</p>
                    <ProjectShareDetails setClickShowShareProjectPopup={setClickShowShareProjectPopup} dataPost={dataPost} newPost={newPost} setNewPost={setNewPost} project={project} beenSharedBefore={beenSharedBefore} setProjectData={setProjectData} updateContentPost={updateContentPost} />
                    {optionsSelect != ObjectTypeEnum.User && <AllowCode index={index} allPost={allPost} setDataPost={setDataPost} dataPost={dataPost} setPermissinType={setPermissinType} permissinType={permissinType}  ></AllowCode>}
                    {beenSharedBefore ?
                        <div>
                            {dataPost?.shares?.[0]?.targetObjectId === TargetObjectIdEnum.External && <External dataPost={dataPost} />}
                            <div className={classes.BtnsContainer}>
                                <button className={`${editPostFromPosts ? classes.HideDelete : ""} ${classes.Delete}`} onClick={deletePost}> {getRemoveText()}</button>
                                <button onClick={updatePost} className={classes.BtnUpdate}>{texts.saveChanges}</button>
                            </div>
                            {/* <div className={classes.Line}></div> */}
                        </div>
                        :
                        <button onClick={handlePublishPost} className={classes.BtnOk}>{texts.publish}</button>}
                </div>
            </div>

        </>
    )
}
export default EditPost